import {
  computeChecklistScore,
  getReadinessFromBands,
} from './checklistUtils';

const READINESS_SCALE_BANDS = [
  { id: 'not-ready', emoji: '❌', label: 'Не готовы', range: '0-100', min: 0 },
  { id: 'partial', emoji: '⚠️', label: 'Частично готовы', range: '101-200', min: 101 },
  { id: 'ready', emoji: '✅', label: 'Можно внедрять', range: '201-230', min: 201 },
];

const BLOG_CLASSIFICATION_URL =
  'https://antologia.tech/blog/klassifikaciya-ii-reshenij-chat-rag-agent-harness';

function slugifyBlockId(title) {
  const map = {
    Процессы: 'processes',
    Команда: 'team',
    Инструменты: 'tools',
    Контент: 'content',
    Бюджет: 'budget',
  };
  return map[title] || title;
}

function buildSalesPilotSection({ lead, score, maxScore, icpFields }) {
  const triggerLabel =
    icpFields?.triggers?.find((item) => item.value === lead.trigger)?.label || '';
  const targetType =
    lead.trigger === 'manual_content' || lead.trigger === 'sales_load' ? 'Harness' : 'Агент';
  const startType = score >= 201 ? 'Агент' : 'Агент';

  const bullets = [
    'Система сама планирует шаги и вызывает инструменты. Высокий потенциал и риск — нужны владелец процесса и обвязка.',
  ];

  if (triggerLabel) {
    bullets.push(`Вы отметили: ${triggerLabel.toLowerCase()}.`);
  }

  bullets.push(
    `По задачам это уровень «${targetType}», но при текущей готовности (${score} из ${maxScore}) разумнее начать пилот с «${startType}» и сузить контур.`,
  );

  if (targetType === 'Harness') {
    bullets.push(
      'Harness оправдан, когда есть поток задач в проде и обвязка (лимиты, логи, human-in-the-loop) — не как первый шаг пилота.',
    );
  }

  return {
    title: 'С чего начать пилот',
    solutionType: startType,
    summary: `Целевой уровень по задачам: ${targetType}.`,
    bullets,
    linkLabel: 'Подробнее: классификация ИИ-решений →',
    linkHref: BLOG_CLASSIFICATION_URL,
  };
}

function buildReadinessScale(score, readinessBands) {
  const active = getReadinessFromBands(score, readinessBands);
  return READINESS_SCALE_BANDS.map((band) => ({
    ...band,
    active: active.min === band.min,
  }));
}

function buildEmailBlocks(checklistData, answers, scaleMax) {
  return checklistData.blocks.map((block) => {
    const questions = block.questions.map((question) => {
      const questionScore = Number(answers[question.id]) || 0;
      return {
        text: question.text,
        score: questionScore,
        maxScore: scaleMax,
      };
    });
    const score = questions.reduce((sum, item) => sum + item.score, 0);
    const maxScore = questions.length * scaleMax;

    return {
      id: slugifyBlockId(block.title),
      title: block.title,
      description: block.description,
      score,
      maxScore,
      questions,
    };
  });
}

/**
 * Данные для ChecklistSalesEmail из ответов sales-чек-листа.
 */
export function buildChecklistSalesEmailData({
  pageConfig,
  answers,
  checklistData,
  lead,
  meta,
  readinessBands,
}) {
  const score = answers._score ?? computeChecklistScore(checklistData, answers);
  const readiness = getReadinessFromBands(score, readinessBands);
  const scaleMax = meta.scaleMax ?? 10;

  return {
    eyebrow: 'Чек-лист',
    title: pageConfig.reportTitle || 'Готовность отдела продаж к Generative AI',
    score,
    maxScore: meta.maxScore,
    readinessLabel: readiness.label,
    readinessEmoji: readiness.emoji,
    user: {
      name: lead.name?.trim() || '—',
      company: lead.company?.trim() || '—',
      email: lead.email?.trim() || '—',
    },
    blocks: buildEmailBlocks(checklistData, answers, scaleMax),
    pilot: buildSalesPilotSection({
      lead,
      score,
      maxScore: meta.maxScore,
      icpFields: pageConfig.icpFields,
    }),
    readinessScale: buildReadinessScale(score, readinessBands),
    cta: {
      title: 'Готовы к следующему шагу?',
      subtitle: 'Обсудим стратегию внедрения AI в ваш бизнес',
      buttonLabel: 'Обсудить внедрение AI',
    },
  };
}
